<template>
    <p>
        Para obter os dados de pagamento desta parcela, acesse o portal do credor.
    </p>
</template>
